import {Model} from "./";
import {Api} from "../api";

class ContentModel extends Model {

    constructor() {
        super(new Api("/content"));
    }

    getBannersB2B(thenFunction, errorFunction) {
        this.q.setDopUrl('/banners-b2b');
        this.q.read({}, thenFunction, errorFunction);
    }
 
}

export default new ContentModel();